import "./style.scss";

const StatCard = ({ value, label, bg, text = "white" }) => {
  return (
    <div className={`col-md-2 px-0`}>
      <div className={`shadow-sm rounded-3 text-${text} ${bg} stat-hover d-flex justify-content-center align-items-stretch h-100`}>
        <div className="p-3 text-center">
          <h3 className="fw-bold mb-1">{value || 0}</h3>
          <p className="mb-0 opacity-75">{label}</p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;